<template>
  <div>
    <div class="checkbox">
      <label for="attachments">
        <input name="attachments" id="attachments" v-model="attachments" type="checkbox" />
        {{ lang.get('score-set.form.attachments.label') }}
      </label>
    </div>
    <div
      v-show="attachments === true"
      id="attachment-type-field"
      class="form-group"
    >
      <label for="attachmentTypeFieldId">
        {{ lang.get('score-set.form.attachment_type_field.label') }}
      </label>
      <select-field
        id="attachmentTypeFieldId"
        name="attachmentTypeFieldId"
        :items="attachmentTypeFields"
        value-property="title"
        :empty-option="true"
        :value="fieldId"
        @selected="onFieldSelected"
      ></select-field>
    </div>
    <div v-show="attachments && !!fieldId" class="form-group">
      <label for="attachmentTypes">
        {{ lang.get('score-set.form.attachment_types.label') }}
      </label>
      <multiselect
        :id="attachmentTypes"
        name="attachmentTypes[]"
        :filter="false"
        :counter="false"
        :options="attachmentTypes[fieldId]"
        :selected-options="
          fieldId === attachmentTypeFieldId && selectedAttachmentTypes.length
            ? selectedAttachmentTypes
            : []
        "
        :select-all-label="lang.get('multiselect.select_all')"
      />
    </div>
  </div>
</template>

<script>
import { SelectField, Multiselect } from 'vue-bootstrap';

export default {
  components: {
    SelectField,
    Multiselect
  },
  inject: ['lang'],
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    attachmentTypeFields: {
      type: Array,
      default: () => []
    },
    attachmentTypeFieldId: {
      type: Number,
      default: null
    },
    attachmentTypes: {
      type: Object,
      default: () => ({})
    },
    selectedAttachmentTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      attachments: this.enabled,
      fieldId: this.attachmentTypeFieldId
    };
  },
  methods: {
    onFieldSelected(name, selected) {
      this.fieldId = selected;
    }
  }
};
</script>
